export const fetchFile = async ({fileUrl, folderName}) => {

    try {
        const response = await fetch(process.env.VUE_APP_API_URL + `/file/retrieve?fileUrl=${fileUrl}&folder=${folderName}`);

        const data = await response.json();

        return data.presignedUrl;
    } catch (error) {
        console.log("Error retrieving file: ", error);
        throw error;
    }
}